import http, { httpKeycloak } from '../mpm-config/http-common';
import moment from 'moment';
class UserDataService {
    async getIsFirstConnection() {
        return http(window.keycloak.token)
            .get('/user/isFirstConnection')
            .then((res) => res.data);
    }
    async logout() {
        return http(window.keycloak.token).get('/user/logout');
    }

    async changePassword(data) {
        return http(window.keycloak.token)
            .post(`/detailConnexion/changePassword`, { ...data })
            .then((res) => res.data);
    }

    async changeKeycloakPassword(data) {
        return httpKeycloak(window.keycloak.token).post(`/account/credentials/password`, { ...data });
    }

    async getLastConnection(login) {
        return http(window.keycloak.token)
            .get(`/detailConnexion/lastConnexion/${login}`)
            .then((res) => res.data);
    }

    async saveDateLogin(login, data) {
        return http(window.keycloak.token)
            .post(`/detailConnexion/saveDateLogin/${login}`, { ...data })
            .then((res) => res.data);
    }

    async saveDateLogout(login) {
        return http(window.keycloak.token)
            .post(`/detailConnexion/saveDateLogout/${login}`, { dateLogout: moment().valueOf() })
            .then((res) => res.data);
    }
}

export default new UserDataService();
